interface FiltersProps {
  selectedCategory: string;
  selectedSort: string;
  selectedReadTime: string;
  onCategoryChange: (cat: string) => void;
  onSortChange: (sort: string) => void;
  onReadTimeChange: (rt: string) => void;
  totalCount: number;
}

const categories = [
  'All',
  'Horror',
  'Psychological',
  'Supernatural',
  'Gothic',
  'Thriller',
  'Cosmic Horror',
  'Paranormal',
  'Dark Fantasy',
];

const sortOptions = [
  { value: 'newest', label: 'Newest First' },
  { value: 'top', label: 'Top Rated' },
  { value: 'most_read', label: 'Most Read' },
  { value: 'oldest', label: 'Oldest First' },
];

const readTimeOptions = [
  { value: 'all', label: 'Any Length' },
  { value: 'short', label: 'Short (&lt;5 min)' },
  { value: 'medium', label: 'Medium (5–15 min)' },
  { value: 'long', label: 'Long (&gt;15 min)' },
];

const StoriesFilters = ({
  selectedCategory,
  selectedSort,
  selectedReadTime,
  onCategoryChange,
  onSortChange,
  onReadTimeChange,
  totalCount,
}: FiltersProps) => {
  return (
    <div className="bg-[#0f0f0f] border-b border-red-900/20 sticky top-16 z-40">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col gap-3">
          {/* Category Pills — wraps on mobile */}
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => onCategoryChange(cat)}
                className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap cursor-pointer transition-all duration-200 font-['Crimson_Text'] ${
                  selectedCategory === cat
                    ? 'bg-red-600 text-white shadow-lg shadow-red-900/40'
                    : 'bg-black/40 text-gray-400 border border-red-900/20 hover:border-red-600/40 hover:text-white'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Bottom row: story count + filters */}
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-gray-500 text-sm font-['Crimson_Text'] whitespace-nowrap mr-auto">
              {totalCount} stories
            </span>

            <select
              value={selectedReadTime}
              onChange={(e) => onReadTimeChange(e.target.value)}
              className="bg-black/60 border border-red-900/30 text-gray-300 text-sm rounded-md px-3 py-1.5 cursor-pointer focus:outline-none focus:border-red-600/60 font-['Crimson_Text']"
            >
              {readTimeOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.value === 'short'
                    ? 'Short (<5 min)'
                    : opt.value === 'long'
                    ? 'Long (>15 min)'
                    : opt.label}
                </option>
              ))}
            </select>

            <select
              value={selectedSort}
              onChange={(e) => onSortChange(e.target.value)}
              className="bg-black/60 border border-red-900/30 text-gray-300 text-sm rounded-md px-3 py-1.5 cursor-pointer focus:outline-none focus:border-red-600/60 font-['Crimson_Text']"
            >
              {sortOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoriesFilters;
